import apiService from 'src/shared/config/apiService';
import { UploadedFile } from 'src/shared/types/uploadedFile';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export interface UploadRfqFileFromUrlPayload {
  rfq_id: number;
  image_url: string;
  caption?: string;
}

export interface UploadRfqFileFromUrlResponse {
  upload_url: string;
  upload_fields: Record<string, string>;
  file: UploadedFile;
}

export const uploadRfqFileFromUrl = async (
  payload: UploadRfqFileFromUrlPayload
): Promise<UploadRfqFileFromUrlResponse> => {
  try {
    const { data } = await apiService.post<UploadRfqFileFromUrlResponse>(
      `/rfqs/${payload.rfq_id}/file-upload-from-url`,
      {
        image_url: payload.image_url,
        caption: payload.caption
      }
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error, { silent: true });
  }
};
